import axios from 'axios';
import { getUserFromLS } from '../../utils/getUserFromLS';
import { IAsset } from '../../Types/assets';

export const getAsset = (
  assetId: string,
  callback: (response: IAsset) => void,
  errorCallback: (error: any) => void
) => {
  const user = getUserFromLS();
  const URL = `${import.meta.env.VITE_API_BASE_URL}/assets/${assetId}`;

  return axios(URL, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${user.access_token}`
    }
  })
    .then((response) => {
      if (callback != null) {
        callback(response.data as IAsset);
      }
    })
    .catch((error) => {
      console.error('Error fetching asset:', error);
      if (errorCallback != null) {
        errorCallback(error);
      }
    });
};
